import type { Character } from '@/types/screenplay';
import { validateSpeechLanguage, type SpeechLanguage } from '../../supabase/functions/_shared/speech-languages';
export { SPEECH_LANGUAGES, type SpeechLanguage } from '../../supabase/functions/_shared/speech-languages';
export const SPEECH_LANGUAGE_STORAGE_KEY = 'tableread.defaultSpeechLanguage';
export function restoreSpeechLanguage(value: unknown): SpeechLanguage {
  try { return validateSpeechLanguage(value) ?? 'auto'; } catch { return 'auto'; }
}
/** Generation-only copy: never rewrite the writer's saved text or annotations. */
export function withSequenceLanguage(characters: Character[], language: SpeechLanguage): Character[] {
  return characters.map(character => character.sequence ? { ...character, sequence: character.sequence.map(item =>
    item.speechLanguage !== undefined || language === 'auto' ? item : { ...item, speechLanguage: language }) } : character);
}
